<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon info">
      <i class="fa-solid fa-robot"></i>
    </div>
    <div>
      <h2 class="dialog-title">AdGate Assistant</h2>
      <p class="dialog-subtitle">AdGate's smart assistant will help you with your tasks</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onClose()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <div class="chatbot-wrapper">
    <div class="chatbot-messages" #messagesContainer>
      @for (message of messages; track $index) {
        <div class="chat-msg" [class.bot]="message.isBot" [class.user]="!message.isBot">
          {{ message.content }}
        </div>
      }
      @if (isTyping) {
        <div class="chat-msg bot typing-indicator">
          <span></span><span></span><span></span>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<div class="chatbot-input-wrap">
  <input
    class="chatbot-input"
    [(ngModel)]="userInput"
    (keypress)="onKeyPress($event)"
    placeholder="Type your question..."
    autocomplete="off">
  <button class="chatbot-send" (click)="onSendMessage()">
    <i class="fa-solid fa-paper-plane"></i>
  </button>
</div>
